import config from "../config";

/**
 * ลิงก์เชิญผู้สมัคร — ตรงกับ client interview `/:job_question_id/:candidate_id`
 * และกับ hr-landing `buildInterviewCandidateInviteLink`
 */
export function buildInterviewCandidateInviteLink(
    jobQuestionId: string,
    candidateId: string,
    baseUrl?: string,
): string {
    const base = String(baseUrl ?? config.share.url ?? "")
        .trim()
        .replace(/\/+$/, "");
    const jq = String(jobQuestionId ?? "").trim();
    const cid = String(candidateId ?? "").trim();
    if (!base || !jq || !cid) return "";
    return `${base}/${jq}/${cid}`;
}
